import { NodeEdgeMapper, } from '@iotv/datamodel-core';
import ApiGateway from '../aws/api-gateway/ApiGateway';
const apiKey = 'DeviceControlApi';
const debug = process.env.REACT_APP_DEBUG && false;
const echo = async (params) => {
    const path = `/echo/`;
    const apiRes = (await ApiGateway.post(path, params, apiKey));
    if (apiRes.data) {
        debug && console.log('Success, echo', apiRes.data);
    }
    else {
        console.error('Fail, echo', apiRes.err?.message);
    }
};
// The return type for this will be Err Data not status 200 data etc post 2023 05 networkData API change
const deviceControlPayloadSend = async (params) => {
    const path = `/device/payload/send`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlPayloadSend', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlPayloadSend', apiRes);
    }
    return apiRes;
};
const deviceControlProgrammeSequentialSend = async (params) => {
    const path = `/device/control/programme/sequential/send`;
    const apiRes = (await ApiGateway.post(path, params, apiKey));
    if (apiRes.data) {
        debug && console.log('Success, deviceControlProgrammeSequentialSend', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlProgrammeSequentialSend', apiRes.err?.message);
    }
    return apiRes;
};
const deviceControlSequentialProgrammeGetContext = async (params) => {
    const path = `/device/control/programme/sequential/getContext`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlSequentialProgrammeGetContext', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlSequentialProgrammeGetContext', apiRes.err?.message);
    }
    return apiRes;
};
const deviceControlProgrammeRollingSend = async (params) => {
    const path = `/device/control/programme/rolling/send`;
    const apiRes = (await ApiGateway.post(path, params, apiKey));
    if (apiRes.data) {
        debug && console.log('Success, deviceControlProgrammeRollingSend', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlProgrammeRollingSend', apiRes.err?.message);
    }
    return apiRes;
};
const deviceControlProgrammeRollingGetContext = async (params) => {
    const path = `/device/control/programme/rolling/getContext`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlProgrammeRollingGetContext', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlProgrammeRollingGetContext', apiRes.err?.message);
    }
    return apiRes;
};
const deviceControlProgrammeOnDemandSend = async (params) => {
    const path = `/device/control/programme/ondemand/send`;
    const apiRes = (await ApiGateway.post(path, params, apiKey));
    if (apiRes.data) {
        debug && console.log('Success, deviceControlProgrammeOnDemandSend', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlProgrammeOnDemandSend', apiRes.err?.message);
    }
    return apiRes;
};
const deviceControlProgrammeOnDemandGetContext = async (params) => {
    const path = `/device/control/programme/ondemand/getContext`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlProgrammeOnDemandGetContext', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlProgrammeOnDemandGetContext', apiRes.err?.message);
    }
    return apiRes;
};
// The return type for this will be Err Data not status 200 data etc post 2023 05 networkData API change
const deviceControlCommandSend = async (params) => {
    const path = `/device/control/command/send`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlCommandSend', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlCommandSend', apiRes);
    }
    return apiRes;
};
const deviceControlListDownlinkQueue = async (params) => {
    const path = `/device/downlink_queue/list`;
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, deviceControlListDownlinkQueue', apiRes.data);
    }
    else {
        console.error('Fail, deviceControlListDownlinkQueue', apiRes);
    }
    return apiRes;
};
const videoStreamSyncWithSystem = async ({ nodeEdgeMapper }) => {
    const res = { err: null, data: null };
    const path = `/video/resolve/items`;
    const params = { skMapped: nodeEdgeMapper.skMapped };
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, videoStreamSyncWithSystem', apiRes.data);
        res.data = new NodeEdgeMapper(apiRes.data.dehydatedContext);
    }
    else {
        console.error('Fail, videoStreamSyncWithSystem', apiRes);
        res.err = new Error(`Fail, videoStreamSyncWithSystem: ${apiRes.err?.message}`);
    }
    return res;
};
const requestVideoStreamStreaming = async (params) => {
    const path = `/video/control/requestStreaming`;
    debug && console.log('Requesting video stream streaming with params:', params);
    const apiRes = await ApiGateway.post(path, params, apiKey);
    if (apiRes.data) {
        debug && console.log('Success, requestVideoStreamStreaming', apiRes.data);
    }
    else {
        console.error('Fail, requestVideoStreamStreaming', apiRes);
    }
    return apiRes;
};
/**
 * **Device Control DAO**
 *
 * 2025 01 — This provides access to routes currently in a V021 API project.
 * The API is specfic to IoTV devices which support schedules, eg `SolenoidController` v3.
 *
 * The API will be moved to a `lsc` stack in the near future.
 * Until that time, calls to this DAO will fail on projects other than V021.
 */
const DeviceControlDAO = {
    echo,
    device: {
        downlink_queue: {
            list: deviceControlListDownlinkQueue,
        },
        payload: {
            send: deviceControlPayloadSend,
        },
        control: {
            command: {
                send: deviceControlCommandSend,
            },
            programme: {
                sequential: {
                    send: deviceControlProgrammeSequentialSend,
                    getContext: deviceControlSequentialProgrammeGetContext,
                },
                rolling: {
                    send: deviceControlProgrammeRollingSend,
                    getContext: deviceControlProgrammeRollingGetContext,
                },
                ondemand: {
                    send: deviceControlProgrammeOnDemandSend,
                    getContext: deviceControlProgrammeOnDemandGetContext,
                },
            },
        },
    },
    video: {
        resolve: {
            items: videoStreamSyncWithSystem,
        },
        control: {
            requestStreaming: requestVideoStreamStreaming,
        },
    },
};
export { DeviceControlDAO };
